var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { INSURED_RELATIONSHIP_OPTIONS, normalizeRelationship } from '../../../model/InsuredDTO';
import { InsuredServiceService } from '../../../../services/insured-service.service';
import { InsuredModalComponent } from '../../../../modal/insured-modal/insured-modal.component';
import { PolicyService } from '../../../../services/policy-service';
var ProfileInsuredComponent = /** @class */ (function () {
    function ProfileInsuredComponent(insuredService, policyService, toastr) {
        this.insuredService = insuredService;
        this.policyService = policyService;
        this.toastr = toastr;
        this.loading = false;
        this.insureds = [];
        // Pólizas DJ29 del usuario, para el selector de póliza del modal de alta.
        this.policies = [];
        this.modalOpen = false;
        this.editingInsured = null;
        // Estado del diálogo de confirmación de baja de asegurado.
        this.confirmDeleteOpen = false;
        this.insuredToDelete = null;
        this.deleting = false;
    }
    ProfileInsuredComponent.prototype.ngOnInit = function () {
        this.loadPolicies();
        this.load();
    };
    // Carga las pólizas DJ29 (Asistencia Jurídica Familiar) del usuario para el selector del
    // modal de alta, mediante /policies/search filtrando por producto. Son las pólizas sobre
    // las que se pueden dar de alta asegurados.
    ProfileInsuredComponent.prototype.loadPolicies = function () {
        var _this = this;
        this.policyService.getLegalAssistancePolicies()
            .then(function (list) {
            _this.policies = (list || [])
                .filter(function (p) { return p && p.number !== null && p.number !== undefined; })
                .map(function (p) { return ({ sequence: Number(p.number), label: _this.policyLabel(p) }); });
        })
            .catch(function () {
            _this.policies = [];
        });
    };
    ProfileInsuredComponent.prototype.policyLabel = function (policy) {
        var number = policy.number;
        return policy.product ? number + " - " + policy.product : "" + number;
    };
    ProfileInsuredComponent.prototype.load = function () {
        var _this = this;
        this.loading = true;
        this.insuredService.getAll()
            .then(function (result) {
            _this.loading = false;
            _this.insureds = _this.mapInsureds((result && result.response) || []);
        })
            .catch(function () {
            _this.loading = false;
            _this.toastr.error('No se han podido cargar los asegurados.', 'Error de conectividad', { timeOut: 5000 });
        });
    };
    // El listado de Innova no devuelve un nombre completo, así que se calcula aquí para
    // mostrarlo en la tarjeta. La relación de parentesco (TITURELA) sí llega y se propaga
    // con el spread (incluido policySequence, la póliza a la que pertenece el asegurado). La
    // fecha de nacimiento llega en formato ISO (yyyy-MM-dd) y se muestra como dd/mm/yyyy.
    ProfileInsuredComponent.prototype.mapInsureds = function (items) {
        var _this = this;
        return items.map(function (i) { return (__assign({}, i, { fullName: [i.name, i.firstSurname, i.lastName].filter(function (part) { return !!part; }).join(' '), bornDate: _this.toDisplayDate(i.bornDate) })); });
    };
    /** Traduce el código de relación de Innova (TITURELA) a su etiqueta legible. */
    ProfileInsuredComponent.prototype.relationshipLabel = function (code) {
        var value = normalizeRelationship(code);
        var option = INSURED_RELATIONSHIP_OPTIONS.find(function (o) { return o.value === value; });
        return option ? option.label : (code ? code.trim() : '');
    };
    ProfileInsuredComponent.prototype.toDisplayDate = function (isoDate) {
        if (!isoDate) {
            return '';
        }
        var _a = isoDate.split('-'), year = _a[0], month = _a[1], day = _a[2];
        return day + "/" + month + "/" + year;
    };
    ProfileInsuredComponent.prototype.openModal = function () {
        this.editingInsured = null;
        this.modalOpen = true;
    };
    ProfileInsuredComponent.prototype.openEditModal = function (insured) {
        this.editingInsured = insured;
        this.modalOpen = true;
    };
    ProfileInsuredComponent.prototype.closeModal = function () {
        this.modalOpen = false;
        this.editingInsured = null;
    };
    ProfileInsuredComponent.prototype.onSave = function (event) {
        var _this = this;
        var isEditMode = !!this.editingInsured;
        // En modificación la póliza es la del asegurado (no cambia); en alta, la seleccionada
        // en el modal.
        var policySequence = isEditMode ? this.editingInsured.policySequence : event.policySequence;
        var request = isEditMode
            ? this.insuredService.modify(policySequence, event.dto)
            : this.insuredService.create(policySequence, event.dto);
        request
            .then(function () {
            _this.modalOpen = false;
            _this.editingInsured = null;
            _this.load();
        })
            .catch(function () {
            if (_this.insuredModal) {
                _this.insuredModal.setRunning(false);
            }
            var message = isEditMode
                ? 'No se ha podido modificar el asegurado.'
                : 'No se ha podido añadir el asegurado.';
            _this.toastr.error(message, 'Error de conectividad', { timeOut: 5000 });
        });
    };
    /** Abre el diálogo de confirmación de baja del asegurado seleccionado. */
    ProfileInsuredComponent.prototype.remove = function (insured) {
        this.insuredToDelete = insured;
        this.confirmDeleteOpen = true;
    };
    /** Cierra el diálogo de confirmación sin eliminar. */
    ProfileInsuredComponent.prototype.cancelDelete = function () {
        if (this.deleting) {
            return;
        }
        this.confirmDeleteOpen = false;
        this.insuredToDelete = null;
    };
    /** Confirma la baja: llama al servicio con la póliza del asegurado, recarga y notifica. */
    ProfileInsuredComponent.prototype.confirmDelete = function () {
        var _this = this;
        if (this.deleting || !this.insuredToDelete) {
            return;
        }
        this.deleting = true;
        this.insuredService.delete(this.insuredToDelete.policySequence, this.insuredToDelete.documentNumber)
            .then(function () {
            _this.deleting = false;
            _this.confirmDeleteOpen = false;
            _this.insuredToDelete = null;
            _this.toastr.success('Asegurado eliminado correctamente.', undefined, { timeOut: 5000 });
            _this.load();
        })
            .catch(function () {
            _this.deleting = false;
            _this.toastr.error('No se ha podido eliminar el asegurado.', 'Error de conectividad', { timeOut: 5000 });
        });
    };
    // El backend devuelve el número y el prefijo por separado; aquí se recomponen para mostrarlos
    // en el mismo formato que usa el resto de la aplicación: "+34 666999888".
    ProfileInsuredComponent.prototype.formatPhone = function (insured) {
        if (!insured.mobilePhone) {
            return '—';
        }
        if (!insured.mobilePhonePrefix) {
            return insured.mobilePhone;
        }
        return "+" + insured.mobilePhonePrefix + " " + insured.mobilePhone;
    };
    // Un mismo documento puede estar asegurado en varias pólizas DJ29, así que la clave de
    // seguimiento combina la póliza y el documento para que sea única.
    ProfileInsuredComponent.prototype.trackById = function (_index, insured) {
        return (insured.policySequence || '') + "-" + insured.documentNumber;
    };
    return ProfileInsuredComponent;
}());
export { ProfileInsuredComponent };
